
import "E:/gitspace/fs-sxzx-web/src/components/RightContent/index.less?modules";
export default {"account": `account-vTeCObL5`,"userIcon": `userIcon-fMhROQ0B`,"search": `search-gYFU0L_w`,"avatar": `avatar-fwW_zXyg`,"menu": `menu-j_-CpUt9`,"right": `right-Z1_FOpo5`,"action": `action-rjAQ693J`,"name": `name-0KLHseqt`}
